import {TAsyncStatesHandlers} from "../../../../../hooks/use-mutation-hook-wrapper";
import {network, screenings as typesScreenings } from "../../../../../types";
import useQueryHookWrapper from "../../../../../hooks/use-query-hook-wrapper";
import { serviceScreenings } from "../../../../../services";

const useScreeningsGet = (
  arg0?: TAsyncStatesHandlers<
    network.TQueryDefWrapper<typesScreenings.TScreeningJob[]>,
    string
  >,
) => {
  return useQueryHookWrapper<
    network.TQueryDefWrapper<typesScreenings.TScreeningJob[]>,
    string,
    null
  >({
    queryKey: 'screenings-get',
    queryFn: serviceScreenings.getScreenings,
    queryConfig: arg0,
    values: null,
  });
};

export default useScreeningsGet;
